import { z } from "zod";

import copyJson from "./order-input-copy.json";

const copySchema = z.object({
  reloadForm: z.string().min(1),
  editStatus: z.string().min(1),
  issues: z.object({
    chemicalRequired: z.string().min(1),
    purchaseRequestedBy: z.string().min(1),
    purchaseNoCustomerRequestor: z.string().min(1),
    saleNoInternalRequestor: z.string().min(1),
    invalid: z.string().min(1),
  }),
});

export const ORDER_INPUT_COPY = copySchema.parse(copyJson);
